import { render, staticRenderFns } from "./CustomToolbarEditor.vue?vue&type=template&id=7e8f54fe&"
import script from "./CustomToolbarEditor.vue?vue&type=script&lang=js&"
export * from "./CustomToolbarEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports